import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import CTA2 from './cta2'
import './content-list1.css'

const ContentList1 = (props) => {
  return (
    <div className="content-list1-container100 thq-section-padding">
      <div className="content-list1-container101">
        <h2 className="content-list1-text100">
          {props.heading51 ?? (
            <Fragment>
              <span className="content-list1-text206">
                Why Choose Allstream Global?
              </span>
            </Fragment>
          )}
        </h2>
        <p className="content-list1-text101">
          {props.text454 ?? (
            <Fragment>
              <span className="content-list1-text286">
                {' '}
                Because we don’t just help you start a company — we help you run
                it smarter, leaner, and more profitably.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </Fragment>
          )}
        </p>
        <p className="content-list1-text102">
          {props.text455 ?? (
            <Fragment>
              <span className="content-list1-text226">
                {' '}
                Allstream Global is built for modern businesses that want to
                skip the admin headache and focus on growth. We go beyond setup
                — we’re your long-term partner for operations, compliance, HR,
                finance, procurement, IT, and PRO services.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </Fragment>
          )}
        </p>
        <h3 className="content-list1-text103">
          {props.heading52 ?? (
            <Fragment>
              <span className="content-list1-text258">
                What Makes Us Different
              </span>
            </Fragment>
          )}
        </h3>
        <div className="content-list1-container102">
          <div className="content-list1-container103">
            <div className="content-list1-container104">
              <span>
                {props.text456 ?? (
                  <Fragment>
                    <span className="content-list1-text256">Feature</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container105">
              <span>
                {props.text457 ?? (
                  <Fragment>
                    <span className="content-list1-text284">
                      Allstream Global
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container106">
              <span>
                {props.text458 ?? (
                  <Fragment>
                    <span className="content-list1-text264">
                      Traditional Agents
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container107">
              <span>
                {props.text459 ?? (
                  <Fragment>
                    <span className="content-list1-text266">In-House Team</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container108">
            <div className="content-list1-container109">
              <span>
                {props.text460 ?? (
                  <Fragment>
                    <span className="content-list1-text290">
                      Full admin outsourcing after setup
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container110">
              <span>
                {props.text461 ?? (
                  <Fragment>
                    <span className="content-list1-text208">✔️</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container111">
              <span>
                {props.text462 ?? (
                  <Fragment>
                    <span className="content-list1-text251">❌</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container112">
              <span>
                {props.text463 ?? (
                  <Fragment>
                    <span className="content-list1-text222">❌</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container113">
            <div className="content-list1-container114">
              <span>
                {props.text464 ?? (
                  <Fragment>
                    <span className="content-list1-text228">
                      Dedicated account manager
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container115">
              <span>
                {props.text465 ?? (
                  <Fragment>
                    <span className="content-list1-text265">✔️</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container116">
              <span>
                {props.text466 ?? (
                  <Fragment>
                    <span className="content-list1-text279">❌</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container117">
              <span>
                {props.text467 ?? (
                  <Fragment>
                    <span className="content-list1-text285">❌</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container118">
            <div className="content-list1-container119">
              <span>
                {props.text468 ?? (
                  <Fragment>
                    <span className="content-list1-text259">
                      End-to-end support (setup → operations)
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container120">
              <span>
                {props.text469 ?? (
                  <Fragment>
                    <span className="content-list1-text276">✔️</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container121">
              <span>
                {props.text470 ?? (
                  <Fragment>
                    <span className="content-list1-text253">❌</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container122">
              <span>
                {props.text471 ?? (
                  <Fragment>
                    <span className="content-list1-text225">✔️</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container123">
            <div className="content-list1-container124">
              <span>
                {props.text472 ?? (
                  <Fragment>
                    <span className="content-list1-text270">
                      Expert team across 5+ functions
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container125">
              <span>
                {props.text473 ?? (
                  <Fragment>
                    <span className="content-list1-text248">✔️</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container126">
              <span>
                {props.text474 ?? (
                  <Fragment>
                    <span className="content-list1-text275">❌</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container127">
              <span>
                {props.text475 ?? (
                  <Fragment>
                    <span className="content-list1-text211">
                      ✔️ (but expensive)
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container128">
            <div className="content-list1-container129">
              <span>
                {props.text476 ?? (
                  <Fragment>
                    <span className="content-list1-text287">
                      Transparent flat pricing
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container130">
              <span>
                {props.text477 ?? (
                  <Fragment>
                    <span className="content-list1-text205">✔️</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container131">
              <span>
                {props.text478 ?? (
                  <Fragment>
                    <span className="content-list1-text214">❌</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container132">
              <span>
                {props.text479 ?? (
                  <Fragment>
                    <span className="content-list1-text223">❌</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container133">
            <div className="content-list1-container134">
              <span>
                {props.text480 ?? (
                  <Fragment>
                    <span className="content-list1-text262">
                      Scalable as your business grows
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container135">
              <span>
                {props.text481 ?? (
                  <Fragment>
                    <span className="content-list1-text234">✔️</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container136">
              <span>
                {props.text482 ?? (
                  <Fragment>
                    <span className="content-list1-text288">❌</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container137">
              <span>
                {props.text483 ?? (
                  <Fragment>
                    <span className="content-list1-text252">Limited</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
        <h3 className="content-list1-text132">
          {props.heading53 ?? (
            <Fragment>
              <span className="content-list1-text263">
                Real Cost Comparison
              </span>
            </Fragment>
          )}
        </h3>
        <h4 className="content-list1-text133">
          {props.heading54 ?? (
            <Fragment>
              <span className="content-list1-text240">
                <span>Let’s talk numbers — because facts close deals.</span>
                <br></br>
              </span>
            </Fragment>
          )}
        </h4>
        <h4 className="content-list1-text134">
          {props.heading541 ?? (
            <Fragment>
              <span className="content-list1-text282">
                Hiring an In-House Team
              </span>
            </Fragment>
          )}
        </h4>
        <div className="content-list1-container138">
          <div className="content-list1-container139">
            <div className="content-list1-container140">
              <span>
                {props.text484 ?? (
                  <Fragment>
                    <span className="content-list1-text233">Role</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container141">
              <span>
                {props.text485 ?? (
                  <Fragment>
                    <span className="content-list1-text244">
                      Min Average Monthly Salary (AED)
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container142">
              <span>
                {props.text486 ?? (
                  <Fragment>
                    <span className="content-list1-text274">
                      Min Average Annual Cost (AED)
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container143">
            <div className="content-list1-container144">
              <span>
                {props.text487 ?? (
                  <Fragment>
                    <span className="content-list1-text236">HR</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container145">
              <span>
                {props.text488 ?? (
                  <Fragment>
                    <span className="content-list1-text217">7,000</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container146">
              <span>
                {props.text489 ?? (
                  <Fragment>
                    <span className="content-list1-text210">84,000</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container147">
            <div className="content-list1-container148">
              <span>
                {props.text490 ?? (
                  <Fragment>
                    <span className="content-list1-text247">Accounts</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container149">
              <span>
                {props.text491 ?? (
                  <Fragment>
                    <span className="content-list1-text257">8,000</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container150">
              <span>
                {props.text492 ?? (
                  <Fragment>
                    <span className="content-list1-text238">96,000</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container151">
            <div className="content-list1-container152">
              <span>
                {props.text493 ?? (
                  <Fragment>
                    <span className="content-list1-text239">Procurement</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container153">
              <span>
                {props.text494 ?? (
                  <Fragment>
                    <span className="content-list1-text215">6,000</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container154">
              <span>
                {props.text495 ?? (
                  <Fragment>
                    <span className="content-list1-text209">72,000</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container155">
            <div className="content-list1-container156">
              <span>
                {props.text496 ?? (
                  <Fragment>
                    <span className="content-list1-text207">IT</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container157">
              <span>
                {props.text497 ?? (
                  <Fragment>
                    <span className="content-list1-text272">7,000</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container158">
              <span>
                {props.text498 ?? (
                  <Fragment>
                    <span className="content-list1-text260">84,000</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container159">
            <div className="content-list1-container160">
              <span>
                {props.text499 ?? (
                  <Fragment>
                    <span className="content-list1-text278">PRO/Admin</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container161">
              <span>
                {props.text500 ?? (
                  <Fragment>
                    <span className="content-list1-text212">6,000</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container162">
              <span>
                {props.text501 ?? (
                  <Fragment>
                    <span className="content-list1-text268">72,000</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container163">
            <div className="content-list1-container164">
              <span>
                {props.text502 ?? (
                  <Fragment>
                    <span className="content-list1-text216">TOTAL</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container165">
              <span>
                {props.text503 ?? (
                  <Fragment>
                    <span className="content-list1-text255">34,000/mo</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container166">
              <span>
                {props.text504 ?? (
                  <Fragment>
                    <span className="content-list1-text235">408,000/yr</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
        <h4 className="content-list1-text156">
          {props.heading55 ?? (
            <Fragment>
              <span className="content-list1-text261">
                Outsource to Allstream Global
              </span>
            </Fragment>
          )}
        </h4>
        <div className="content-list1-container167">
          <div className="content-list1-container168">
            <div className="content-list1-container169">
              <span>
                {props.text505 ?? (
                  <Fragment>
                    <span className="content-list1-text249">Service</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container170">
              <span>
                {props.text506 ?? (
                  <Fragment>
                    <span className="content-list1-text267">Monthly (AED)</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container171">
              <span>
                {props.text507 ?? (
                  <Fragment>
                    <span className="content-list1-text232">Annual (AED)</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container172">
            <div className="content-list1-container173">
              <span>
                {props.text508 ?? (
                  <Fragment>
                    <span className="content-list1-text243">
                      Full Admin Support Package
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container174">
              <span>
                {props.text509 ?? (
                  <Fragment>
                    <span className="content-list1-text246">12,500</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container175">
              <span>
                {props.text510 ?? (
                  <Fragment>
                    <span className="content-list1-text218">150,000</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
        <h3 className="content-list1-text163">
          {props.heading56 ?? (
            <Fragment>
              <span className="content-list1-text254">📊 Summary</span>
            </Fragment>
          )}
        </h3>
        <div className="content-list1-container176">
          <div className="content-list1-container177">
            <div className="content-list1-container178"></div>
            <div className="content-list1-container179">
              <span>
                {props.text511 ?? (
                  <Fragment>
                    <span className="content-list1-text245">In-House Team</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container180">
              <span>
                {props.text512 ?? (
                  <Fragment>
                    <span className="content-list1-text281">
                      Allstream Global 
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container181">
            <div className="content-list1-container182">
              <span>
                {props.text513 ?? (
                  <Fragment>
                    <span className="content-list1-text271">Monthly Cost</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container183">
              <span>
                {props.text514 ?? (
                  <Fragment>
                    <span className="content-list1-text227">34,000+</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container184">
              <span>
                {props.text515 ?? (
                  <Fragment>
                    <span className="content-list1-text221">12,500</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container185">
            <div className="content-list1-container186">
              <span>
                {props.text516 ?? (
                  <Fragment>
                    <span className="content-list1-text280">Annual Cost</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container187">
              <span>
                {props.text517 ?? (
                  <Fragment>
                    <span className="content-list1-text230">408,000+</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container188">
              <span>
                {props.text518 ?? (
                  <Fragment>
                    <span className="content-list1-text219">150,000</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="content-list1-container189">
            <div className="content-list1-container190">
              <span>
                {props.text519 ?? (
                  <Fragment>
                    <span className="content-list1-text231">
                      Annual Savings
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container191">
              <span>
                {props.text520 ?? (
                  <Fragment>
                    <span className="content-list1-text273">—</span>
                  </Fragment>
                )}
              </span>
            </div>
            <div className="content-list1-container192">
              <span>
                {props.text521 ?? (
                  <Fragment>
                    <span className="content-list1-text237">258,000+</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
      <CTA2
        text={
          <Fragment>
            <span className="content-list1-text175">
              Dedicated professionals in each admin function
            </span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="content-list1-text176">
              Seamless coordination — no juggling vendors or freelancers
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="content-list1-text177">
              Tasks completed faster, with fewer errors
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="content-list1-text178">
              Fixed monthly fee = predictable budgeting
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="content-list1-text179">
              No recruitment, no salaries, no end-of-service liabilities
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="content-list1-text180">
              Zero training or onboarding delays
            </span>
          </Fragment>
        }
        text6={
          <Fragment>
            <span className="content-list1-text181">
              Scale services up or down based on your business size
            </span>
          </Fragment>
        }
        text7={
          <Fragment>
            <span className="content-list1-text182">
              Flexible support — from startup mode to expansion
            </span>
          </Fragment>
        }
        text8={
          <Fragment>
            <span className="content-list1-text183">
              Only pay for what you need, when you need it
            </span>
          </Fragment>
        }
        text9={
          <Fragment>
            <span className="content-list1-text184">
              Stay compliant with UAE labor law, VAT, and WPS
            </span>
          </Fragment>
        }
        text10={
          <Fragment>
            <span className="content-list1-text185">
              Avoid costly fines, renewals, and license lapses
            </span>
          </Fragment>
        }
        text11={
          <Fragment>
            <span className="content-list1-text186">
              Expert advisory for government relations and policy changes
            </span>
          </Fragment>
        }
        text12={
          <Fragment>
            <span className="content-list1-text187">
              Dedicated point of contact
            </span>
          </Fragment>
        }
        text13={
          <Fragment>
            <span className="content-list1-text188">
              Transparent communication
            </span>
          </Fragment>
        }
        text14={
          <Fragment>
            <span className="content-list1-text189">
              Proactive problem-solving, not reactive firefighting
            </span>
          </Fragment>
        }
        heading={
          <Fragment>
            <span className="content-list1-text190">
              Benefits You Actually Feel
            </span>
          </Fragment>
        }
        heading2={
          <Fragment>
            <span className="content-list1-text191">
              🔧 Operational Efficiency
            </span>
          </Fragment>
        }
        heading3={
          <Fragment>
            <span className="content-list1-text192">
              💰 Massive Cost Savings
            </span>
          </Fragment>
        }
        heading4={
          <Fragment>
            <span className="content-list1-text193">
              📈 Scalability &amp; Growth
            </span>
          </Fragment>
        }
        heading5={
          <Fragment>
            <span className="content-list1-text194">
              🔐 100% Compliance, Zero Risk
            </span>
          </Fragment>
        }
        heading6={
          <Fragment>
            <span className="content-list1-text195">
              🤝 Relationship-Driven Service
            </span>
          </Fragment>
        }
      ></CTA2>
      <div className="content-list1-container193">
        <h2 className="content-list1-text196">
          {props.heading63 ?? (
            <Fragment>
              <span className="content-list1-text220">
                Who This is Perfect For
              </span>
            </Fragment>
          )}
        </h2>
        <div className="content-list1-container194">
          <div className="content-list1-container195">
            <h3 className="content-list1-text197">
              {props.heading64 ?? (
                <Fragment>
                  <span className="content-list1-text250">Startups</span>
                </Fragment>
              )}
            </h3>
            <p className="content-list1-text198">
              {props.text537 ?? (
                <Fragment>
                  <span className="content-list1-text277">
                    Who want to focus on product, not paperwork
                  </span>
                </Fragment>
              )}
            </p>
          </div>
          <div className="content-list1-container196">
            <h3 className="content-list1-text199">
              {props.heading65 ?? (
                <Fragment>
                  <span className="content-list1-text224">SMEs</span>
                </Fragment>
              )}
            </h3>
            <p className="content-list1-text200">
              {props.text538 ?? (
                <Fragment>
                  <span className="content-list1-text283">
                    Who want expert admin without bloated overhead
                  </span>
                </Fragment>
              )}
            </p>
          </div>
          <div className="content-list1-container197">
            <h3 className="content-list1-text201">
              {props.heading66 ?? (
                <Fragment>
                  <span className="content-list1-text213">
                    International Companies
                  </span>
                </Fragment>
              )}
            </h3>
            <p className="content-list1-text202">
              {props.text539 ?? (
                <Fragment>
                  <span className="content-list1-text229">
                    Launching UAE branches
                  </span>
                </Fragment>
              )}
            </p>
          </div>
          <div className="content-list1-container198">
            <h3 className="content-list1-text203">
              {props.heading67 ?? (
                <Fragment>
                  <span className="content-list1-text289">Business Owners</span>
                </Fragment>
              )}
            </h3>
            <p className="content-list1-text204">
              {props.text540 ?? (
                <Fragment>
                  <span className="content-list1-text269">
                    Who don’t want to manage an office full of admin staff
                  </span>
                </Fragment>
              )}
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className="content-list1-container200">
          <Script
            html={`<script>
              (function(){
  const faqs = document.querySelectorAll("div button");
  faqs.forEach(btn => {
    btn.addEventListener("click", () => {
      const panel = btn.nextElementSibling;
      panel.style.display = panel.style.display === "block" ? "none" : "block";
    });
  });
})()
              </script>`}
          ></Script>
        </div>
      </div>
      <div>
        <div className="content-list1-container202">
          <Script
            html={`<script>
              (function(){
  const cards = document.querySelectorAll("div[style*='transition']");
  cards.forEach(card => {
    card.addEventListener("mouseenter", () => {
      card.style.transform = "translateY(-5px)";
      card.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
    });
    card.addEventListener("mouseleave", () => {
      card.style.transform = "translateY(0)";
      card.style.boxShadow = "0 4px 10px rgba(0,0,0,0.05)";
    });
  });
})()
              </script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

ContentList1.defaultProps = {
  text477: undefined,
  heading51: undefined,
  text496: undefined,
  text461: undefined,
  text495: undefined,
  text489: undefined,
  text475: undefined,
  text500: undefined,
  heading66: undefined,
  text478: undefined,
  text494: undefined,
  text502: undefined,
  text488: undefined,
  text510: undefined,
  text518: undefined,
  heading63: undefined,
  text515: undefined,
  text463: undefined,
  text479: undefined,
  heading65: undefined,
  text471: undefined,
  text455: undefined,
  text514: undefined,
  text464: undefined,
  text539: undefined,
  text517: undefined,
  text519: undefined,
  text507: undefined,
  text484: undefined,
  text481: undefined,
  text504: undefined,
  text487: undefined,
  text521: undefined,
  text492: undefined,
  text493: undefined,
  heading54: undefined,
  text508: undefined,
  text485: undefined,
  text511: undefined,
  text509: undefined,
  text490: undefined,
  text473: undefined,
  text505: undefined,
  heading64: undefined,
  text462: undefined,
  text483: undefined,
  text470: undefined,
  heading56: undefined,
  text503: undefined,
  text456: undefined,
  text491: undefined,
  heading52: undefined,
  text468: undefined,
  text498: undefined,
  heading55: undefined,
  text480: undefined,
  heading53: undefined,
  text458: undefined,
  text465: undefined,
  text459: undefined,
  text506: undefined,
  text501: undefined,
  text540: undefined,
  text472: undefined,
  text513: undefined,
  text497: undefined,
  text520: undefined,
  text486: undefined,
  text474: undefined,
  text469: undefined,
  text537: undefined,
  text499: undefined,
  text466: undefined,
  text516: undefined,
  text512: undefined,
  heading541: undefined,
  text538: undefined,
  text457: undefined,
  text467: undefined,
  text454: undefined,
  text476: undefined,
  text482: undefined,
  heading67: undefined,
  text460: undefined,
}

ContentList1.propTypes = {
  text477: PropTypes.element,
  heading51: PropTypes.element,
  text496: PropTypes.element,
  text461: PropTypes.element,
  text495: PropTypes.element,
  text489: PropTypes.element,
  text475: PropTypes.element,
  text500: PropTypes.element,
  heading66: PropTypes.element,
  text478: PropTypes.element,
  text494: PropTypes.element,
  text502: PropTypes.element,
  text488: PropTypes.element,
  text510: PropTypes.element,
  text518: PropTypes.element,
  heading63: PropTypes.element,
  text515: PropTypes.element,
  text463: PropTypes.element,
  text479: PropTypes.element,
  heading65: PropTypes.element,
  text471: PropTypes.element,
  text455: PropTypes.element,
  text514: PropTypes.element,
  text464: PropTypes.element,
  text539: PropTypes.element,
  text517: PropTypes.element,
  text519: PropTypes.element,
  text507: PropTypes.element,
  text484: PropTypes.element,
  text481: PropTypes.element,
  text504: PropTypes.element,
  text487: PropTypes.element,
  text521: PropTypes.element,
  text492: PropTypes.element,
  text493: PropTypes.element,
  heading54: PropTypes.element,
  text508: PropTypes.element,
  text485: PropTypes.element,
  text511: PropTypes.element,
  text509: PropTypes.element,
  text490: PropTypes.element,
  text473: PropTypes.element,
  text505: PropTypes.element,
  heading64: PropTypes.element,
  text462: PropTypes.element,
  text483: PropTypes.element,
  text470: PropTypes.element,
  heading56: PropTypes.element,
  text503: PropTypes.element,
  text456: PropTypes.element,
  text491: PropTypes.element,
  heading52: PropTypes.element,
  text468: PropTypes.element,
  text498: PropTypes.element,
  heading55: PropTypes.element,
  text480: PropTypes.element,
  heading53: PropTypes.element,
  text458: PropTypes.element,
  text465: PropTypes.element,
  text459: PropTypes.element,
  text506: PropTypes.element,
  text501: PropTypes.element,
  text540: PropTypes.element,
  text472: PropTypes.element,
  text513: PropTypes.element,
  text497: PropTypes.element,
  text520: PropTypes.element,
  text486: PropTypes.element,
  text474: PropTypes.element,
  text469: PropTypes.element,
  text537: PropTypes.element,
  text499: PropTypes.element,
  text466: PropTypes.element,
  text516: PropTypes.element,
  text512: PropTypes.element,
  heading541: PropTypes.element,
  text538: PropTypes.element,
  text457: PropTypes.element,
  text467: PropTypes.element,
  text454: PropTypes.element,
  text476: PropTypes.element,
  text482: PropTypes.element,
  heading67: PropTypes.element,
  text460: PropTypes.element,
}

export default ContentList1
